// @flow
import React from 'react';
import PropTypes from 'prop-types';

import './GettingStartedCaption.scss';

type Props = {
  title: string,
  text: string,
  children: Node,
};
const GettingStartedCaptionComponent = ({ title, text, children }: Props) => (
  <figcaption className="getting-started-caption-component">
    <div className="getting-started-caption-component__title">{title}</div>
    <p className="getting-started-caption-component__text">{text}</p>
    {children}
  </figcaption>
);

GettingStartedCaptionComponent.propTypes = {
  title: PropTypes.node.isRequired,
  text: PropTypes.node.isRequired,
  children: PropTypes.node,
};

GettingStartedCaptionComponent.defaults = {
  children: [],
};

GettingStartedCaptionComponent.displayName = 'GettingStartedCaption';

export default GettingStartedCaptionComponent;
